import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 3C1 1.89543 1.89543 1 3 1H15C16.1046 1 17 1.89543 17 3V15C17 16.1046 16.1046 17 15 17H3C1.89543 17 1 16.1046 1 15V3Z"
      fill="#FFB743"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5557 11.6666V7.22211H5.44455V11.6666H12.5557ZM5.44455 5.44434H12.5557C12.7914 5.44434 13.0175 5.53799 13.1842 5.70469C13.3509 5.87138 13.4446 6.09748 13.4446 6.33322V11.6666C13.4446 11.9023 13.3509 12.1284 13.1842 12.2951C13.0175 12.4618 12.7914 12.5554 12.5557 12.5554H5.44455C5.2088 12.5554 4.98271 12.4618 4.81601 12.2951C4.64931 12.1284 4.55566 11.9023 4.55566 11.6666V6.33322C4.55566 6.09748 4.64931 5.87138 4.81601 5.70469C4.98271 5.53799 5.2088 5.44434 5.44455 5.44434Z"
      fill="white"
    />
    <ellipse
      cx={14}
      cy={14}
      rx={5}
      ry={5}
      fill="#37363F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.8083 12.5149C16.3434 12.8565 16.7575 13.3444 16.9964 13.9143C17.0012 13.9427 17.0012 13.9717 16.9964 14.0001C16.9973 14.0323 16.9912 14.0644 16.9784 14.0943C16.7392 14.66 16.3272 15.1441 15.7958 15.4839C15.2644 15.8237 14.6381 16.0035 13.9982 15.9999C13.3575 16.003 12.7307 15.8224 12.1993 15.4815C11.6678 15.1407 11.2562 14.6553 11.018 14.0886C11.006 14.0605 10.9998 14.0304 11 14.0001C11.0004 13.9679 11.0065 13.936 11.018 13.9058C11.2571 13.3401 11.6691 12.856 12.2005 12.5162C12.7319 12.1764 13.3582 11.9966 13.9982 12.0002C14.6422 11.9939 15.2732 12.1733 15.8083 12.5149ZM12.5937 15.0402C13.0143 15.2929 13.501 15.4275 13.9982 15.4286C14.4953 15.4275 14.9821 15.2929 15.4026 15.0402C15.8231 14.7876 16.1604 14.4271 16.3757 14.0001C16.1612 13.5725 15.8241 13.2116 15.4034 12.9589C14.9826 12.7062 14.4955 12.5721 13.9982 12.5721C13.5009 12.5721 13.0137 12.7062 12.593 12.9589C12.1723 13.2116 11.8352 13.5725 11.6206 14.0001C11.8359 14.4271 12.1732 14.7876 12.5937 15.0402ZM14.3313 13.525C14.2327 13.4622 14.1168 13.4287 13.9982 13.4287C13.8391 13.4287 13.6866 13.4889 13.5742 13.596C13.4617 13.7032 13.3985 13.8485 13.3985 14.0001C13.3985 14.1131 13.4337 14.2235 13.4996 14.3175C13.5655 14.4115 13.6591 14.4847 13.7687 14.528C13.8783 14.5712 13.9988 14.5825 14.1152 14.5605C14.2315 14.5384 14.3383 14.484 14.4222 14.4041C14.506 14.3242 14.5632 14.2224 14.5863 14.1115C14.6094 14.0007 14.5976 13.8858 14.5522 13.7814C14.5068 13.677 14.4299 13.5877 14.3313 13.525ZM13.3319 13.0499C13.5291 12.9243 13.761 12.8573 13.9982 12.8573C14.3162 12.8573 14.6213 12.9777 14.8462 13.192C15.0711 13.4063 15.1974 13.697 15.1974 14.0001C15.1974 14.2261 15.1271 14.447 14.9953 14.635C14.8636 14.8229 14.6763 14.9694 14.4571 15.0559C14.238 15.1424 13.9968 15.165 13.7642 15.1209C13.5316 15.0768 13.3179 14.968 13.1502 14.8081C12.9824 14.6483 12.8682 14.4447 12.822 14.223C12.7757 14.0013 12.7994 13.7715 12.8902 13.5627C12.981 13.3539 13.1347 13.1754 13.3319 13.0499Z"
      fill="white"
    />
  </svg>
);
const SvgDemoPreviewTab = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgDemoPreviewTab;
